import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ontarioConfig } from "./data";

export default function OntarioPage() {
  return <CityPageTemplate config={ontarioConfig} />;
}